import { Component, AfterViewInit, OnInit, ElementRef, ViewChildren, QueryList } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormlyFieldConfig, FormlyModule } from '@ngx-formly/core';
import { SmartusComponentsModule } from '@affinis/smartus-components';
import { MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';



@Component({
  selector: 'app-confirmation-code',
  imports: [SmartusComponentsModule, FormlyModule],
  templateUrl: './confirmation-code.component.html',
  styleUrl: './confirmation-code.component.scss'
})
export class ConfirmationCodeComponent implements OnInit, AfterViewInit{


  title: string = this.translateService.instant('invoice.settings.validation_code.title');
  message: string = this.translateService.instant('invoice.settings.validation_code.message');
  confirmText = this.translate('shared.confirm');
  cancelText = this.translate('shared.cancel');
  
  form = new FormGroup({});
  formFields: FormlyFieldConfig[]; 
  formModel: any ={
    digit0: '',
    digit1: '',
    digit2: '',
    digit3: '',
    digit4: '',
    digit5: ''
  };
  

  constructor(
    private dialogRef: MatDialogRef<ConfirmationCodeComponent>,
    private readonly translateService: TranslateService,
    private element: ElementRef
  )
  {
  }

  ngOnInit(): void {

    this.formFields = [
        {
          fieldGroupClassName: 'row',
          fieldGroup: Array.from({ length: 6 }).map((_, i) => ({
              key: `digit${i}`,
              type: 'input',
              className: 'otp-input, col-2',
              props: {
                maxLength: 1,
                required: true,
                pattern: '\\d',
                attributes: {
                  autocomplete: 'something', // suppress autofill
                  name: 'something-unique' // suppress autofill
                },                
              },
              validation: {
                messages: {
                  required: () => '', // no message shown
                },   
              }  
            })),
        },
      ]
  }

  ngAfterViewInit() {
    
    setTimeout(() => {
      this.setupOtpAutofocus();
    }, 0);
  }

  setupOtpAutofocus() {

    const inputs = Array.from(this.element.nativeElement.querySelectorAll('input') as HTMLInputElement[]);
    if (inputs.length > 0) {
      inputs[0].focus();
      inputs.forEach((input, index) => {
        input.addEventListener('input', () => {
          if (input.value.length >= 1 && input.value.length < 6) inputs[index + 1]?.focus();
          if(input.attributes.getNamedItem('id')?.value.includes('digit5')) this.submitForm();
        });
        
        input.addEventListener('keydown', (event) => {
          if (event.key === 'Backspace' && input.value === '') inputs[index - 1]?.focus();
        });
      });
    }
  }

  translate(key: string): string {
    return this.translateService.instant(key);
  }

  submitForm() {
    if (this.form.valid) {
      const otp = Object.values(this.formModel).join('');
      this.dialogRef.close(otp);
    }
  }

  closeDialog() {
    this.dialogRef.close();
  }
}
